<template>
    <section class="products-section">
        <div class="filter-section" v-if="segments.length > 0 || productTypes.length > 0 || markets.length > 0">
            <div class="filter-items">
                <div class="filter-item filter-item--mw" v-if="segments.length > 0 && !hideSegments">
                    <label class="sr-only"
                                for="segmentsFilter">{{ dictionaries.ProductSegmentOptionDefault }}</label>
                    <select id="segmentsFilter" name="segmentsFilter" @change="filterChanged" :disabled="isLoading" v-model="segment" class="filter-item__select">
                        <option value="All">{{dictionaries.ProductSegmentOptionDefault}}</option>
                        <option :value="segment.Key" v-for="(segment, index) in segments" v-if="segment.Name">{{segment.Name}}</option>
                    </select>
                </div>
                <div class="filter-item filter-item--mw" v-if="productTypes.length > 0">
                    <label class="sr-only"
                                for="productTypeFilter">{{ dictionaries.ProductTypeOptionDefault }}</label>
                    <select id="productTypeFilter" name="productTypeFilter" @change="filterChanged" :disabled="isLoading" v-model="productType" class="filter-item__select">
                        <option value="All">{{dictionaries.ProductTypeOptionDefault}}</option>
                        <option :value="productType.Key" v-for="(productType, index) in productTypes" v-if="productType.Name">{{productType.Name}}</option>
                    </select>
                </div>
                <div class="filter-item filter-item--mw" v-if="markets.length > 0">
                    <label class="sr-only"
                                for="marketFilter">{{ dictionaries.ProductMarketOptionDefault }}</label>
                    <select id="marketFilter" name="marketFilter" @change="filterChanged" :disabled="isLoading" v-model="market" class="filter-item__select">
                        <option value="All">{{dictionaries.ProductMarketOptionDefault}}</option>
                        <option :value="market.Key" v-for="(market, index) in markets" v-if="market.Name">{{market.Name}}</option>
                    </select>
                </div>
                <div class="filter-item">
                    <button type="button" class="filter-item__button" @click="resetFilter" :disabled="isLoading">{{dictionaries.ProductFilterReset}}</button>
                </div>
            </div>
        </div>
        <div class="products-items" v-show="products.length">
            <productItem v-for="productItem in products" :productItem="productItem" :key="productItem.Id"></productItem>
        </div>
        <div class="products-items__no-result" v-show="!products.length && !isLoading">{{dictionaries.ProductNoResult}}</div>
        <div class="products-items__cta" v-show="hasMoreProductsToLoad">
            <a @click="getNextPage" :disabled="isLoading" class="products-items__load-more">{{dictionaries.ProductLoadMore}}</a>
        </div>
    </section>
</template>

<script>
    import ProductItem from "./components/productItem.vue";
    import { bindRoute } from "./mixins/bindroute.js";

    const serviceUrl = "/umbraco/api/products/getproducts",
        defaultPage = 1,
        defaultSegment = "All",
        defaultProductType = "All",
        defaultMarket = "All";

    export default {
        name: "products",
        components: {
            ProductItem
        },
        data() {
            return {
                dictionaries: [],
                segments: [],
                productTypes: [],
                markets: [],
                products: [],
                pageSize: 16,
                totalProducts: 0,
                isLoading: false
            };
        },
        created() {
            this.productsPageId = this.$parent.productsPageId;
            this.getInitialProducts();
        },
        mixins: [
            bindRoute({
                page: defaultPage,
                segment: defaultSegment,
                productType: defaultProductType,
                market: defaultMarket,
                hideSegments:false
            })
        ],
        methods: {
            getProducts(amountToSkip, pageSize) {
                var vm = this,
                    languageCode = $("html").attr("lang");
                vm.toggleSpinner(true);
                var object = {
                    languageCode: languageCode,
                    amountToSkip: amountToSkip,
                    pageSize: pageSize
                };
                if (this.segment != defaultSegment) {
                    object.segment = this.segment;
                }
                if (this.productType != defaultProductType) {
                    object.productType = this.productType;
                }
                if (this.market != defaultMarket) {
                    object.market = this.market;
                }
                if (this.productsPageId) {
                    object.productsPageId = this.productsPageId;
                }
                $.get(serviceUrl, object, function (response) {
                    vm.dictionaries = response.Dictionaries;
                    vm.segments = response.Facets.Segments;
                    vm.productTypes = response.Facets.ProductTypes;
                    vm.markets = response.Facets.Markets;
                    vm.products.push(...response.Items);
                    vm.totalProducts = response.TotalItems;
                }).fail(function (error) {
                    console.log(error);
                }).always(function () {
                    vm.toggleSpinner(false);
                });
            },
            getNextPage() {
                if (!this.isLoading) {
                    this.page++;
                    this.getProducts(this.pageSize * (this.page - 1), this.pageSize);
                }
            },
            getInitialProducts() {
                // Get all products up to, and including, the current page
                const initialPageSize = this.pageSize * this.page;
                this.getProducts(0, initialPageSize);
            },
            toggleSpinner: function (isLoading) {
                this.isLoading = isLoading;
                if (isLoading) {
                    $("body").addClass("is-loading");
                } else {
                    $("body").removeClass("is-loading");
                }
            },
            filterChanged() {
                this.products = [];
                this.totalProducts = 0;
                this.page = defaultPage;
                this.getProducts(0, this.pageSize);
            },
            resetFilter() {
                this.products = [];
                this.totalProducts = 0;
                this.page = defaultPage;
                this.segment = !this.hideSegments ? defaultSegment : this.segment;
                this.productType = defaultProductType;
                this.market = defaultMarket;
                this.getProducts(0, this.pageSize);
            }
        },
        computed: {
            hasMoreProductsToLoad() {
                return this.totalProducts !== 0 && this.products.length < this.totalProducts;
            }
        }
    };
</script>